import { render, staticRenderFns } from "./creditHour.vue?vue&type=template&id=23e0c5ca&scoped=true&"
import script from "./creditHour.vue?vue&type=script&lang=js&"
export * from "./creditHour.vue?vue&type=script&lang=js&"
import style0 from "./creditHour.vue?vue&type=style&index=0&id=23e0c5ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e0c5ca",
  null
  
)

export default component.exports